const selectBox = document.getElementById('delivery-time');
const selectBox02= document.getElementById('delivery-date');
const selectBox03= document.getElementById('gift-checkbox');

function postData() {
  const selectedValue = selectBox.value;
  const selectedValue02 = selectBox02.value;
　const selectedValue03 = selectBox03.value;
  
  const attributes = {
    attributes: {
      'delivery-time': selectedValue,
      'delivery-date': selectedValue02,
  　  'gift-wrapping': selectedValue03
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(attributes),
  })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

selectBox.addEventListener('change', postData);
selectBox02.addEventListener('change', postData);
selectBox03.addEventListener('change', postData);






/*
const selectBox = document.getElementById('delivery-time');

function postData() {
  const selectedValue = selectBox.value;
  const attributes = {
    attributes: {
      'delivery-time': selectedValue
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(attributes),
  })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

selectBox.addEventListener('change', postData);



const selectBox02= document.getElementById('delivery-date');

function postData() {
  const selectedValue = selectBox02.value;
  const attributes = {
    attributes: {
      'delivery-date': selectedValue
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(attributes),
  })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

selectBox02.addEventListener('change', postData);
*/